import Vue from 'vue'
import Vuex from 'vuex'

import admin from './admin'
import auth from './auth'
import campaign from './campaign'

import behavioralCompetencies from './behavioral_competencies'
import disciplines from './disciplines'
import geolocation from './geolocation'
import institutions from './institutions'
import opportunities from './opportunities'
import organizations from './organizations'
import qualificationCategories from './qualification_categories'
import qualificationComponents from './qualification_components'
import qualificationTypes from './qualification_types'
import qualifications from './qualifications'
import requirements from './requirements'

import authorize from './plugins/authorize'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    // Role modules
    admin,
    // Auth module
    auth,
    campaign,
    // Public endpoints
    behavioralCompetencies,
    disciplines,
    geolocation,
    institutions,
    opportunities,
    organizations,
    qualificationCategories,
    qualificationComponents,
    qualificationTypes,
    qualifications,
    requirements,
  },
  plugins: [authorize],
  state: {
    drawer: false,
    snackbar: null
  },
  getters: {
    snackbar: state => state.snackbar
  },
  mutations: {
    toggleDrawer: state => (state.drawer = !state.drawer),
    closeDrawer: state => (state.drawer = false),
    snackbar: (state, details) =>
      (state.snackbar = details ? Object.assign({ timeout: 6000, type: 'info' }, details) : null)
  },
  actions: {
    snackbarShow({ commit }, message) {
      commit('snackbar', {
        text: message
      })
    },
    snackbarSuccess({ commit }, message) {
      commit('snackbar', {
        text: message,
        type: 'success'
      })
    },
    snackbarError({ commit }, message) {
      commit('snackbar', {
        text: message,
        type: 'error'
      })
    }
  }
})

export default store
